// Generated by CoffeeScript 1.12.7
//require('../../../core/frontend/vendor_modules/jquery-2.1.4.js');
/* global _fixedFormDivNoSuggestMargin:false, document: false, I18n: false, subsI18n:false, _fixedFormDivSuggestMargin:false*/

function emailSuggestions() {
  let commonDomains, emailField;
  const onEmailSuggestionClicked = function(e) {
    e.preventDefault();
    const link = this;
    const newVal = link['fullEmail'];
    emailField.value = newVal;
    emailField.change();
    link.parentNode.parentNode.removeChild(link.parentNode);
    if (
      typeof _fixedFormDivNoSuggestMargin !== 'undefined' &&
      _fixedFormDivNoSuggestMargin !== null
    ) {
      document.getElementById(
        'fixed-form-div'
      ).style.paddingBottom = _fixedFormDivNoSuggestMargin;
    }
  };
  const getTruncatedEmail = function(fullAddress, domain) {
    if (fullAddress == null) {
      fullAddress = '';
    }
    if (domain == null) {
      domain = '';
    }
    const truncatedAddress = fullAddress.slice(-6);
    if (truncatedAddress !== fullAddress) {
      if (document.body.classList.contains('rtl')) {
        return `${truncatedAddress}@${domain}...`;
      } else {
        return `...${truncatedAddress}@${domain}`;
      }
    } else {
      return `${fullAddress}@${domain}`;
    }
  };
  const getEmailSuggestion = function() {
    let suggDisplay = emailField.parentNode.querySelectorAll('.suggestion');
    suggDisplay = Array.prototype.filter.call(
      suggDisplay,
      child => !child.isSameNode(emailField)
    );
    return emailField.mailcheck({
      domains: commonDomains,
      suggested(element, suggestion) {
        let i18nObj, output, truncatedEmail;
        const val = emailField.value;
        i18nObj = I18n;
        if (typeof subsI18n !== 'undefined' && subsI18n !== null) {
          i18nObj = subsI18n;
        }
        if (/@.+\./.test(val) && suggestion.full.slice(0, val.length) !== val) {
          truncatedEmail = getTruncatedEmail(
            decodeURIComponent(suggestion.address),
            decodeURIComponent(suggestion.domain)
          );
          output = i18nObj.translate(
            'js.modules.subscription.subscribe.email_step.suggest_email',
            {
              link_open: "<a href='#' class='accept-suggestion'>",
              suggested_email: truncatedEmail,
              link_close: '</a>',
            }
          );
          if (
            typeof _fixedFormDivSuggestMargin !== 'undefined' &&
            _fixedFormDivSuggestMargin !== null
          ) {
            document.getElementById(
              'fixed-form-div'
            ).style.paddingBottom = _fixedFormDivSuggestMargin;
          }
          if (!suggDisplay[0]) {
            suggDisplay = document.createElement('div');
            suggDisplay.classList.add('suggestion');
            suggDisplay.setAttribute('data-bhw', 'EmailSuggestion');
            emailField.insertAdjacentElement('afterend', suggDisplay);
          }
          suggDisplay.innerHTML = output;
          document.querySelectorAll('.accept-suggestion').forEach(elem => {
            elem.fullEmail = decodeURIComponent(suggestion.full);
          });
        } else {
          if (suggDisplay && suggDisplay[0])
            suggDisplay[0].parentNode.removeChild(suggDisplay[0]);
          if (
            typeof _fixedFormDivNoSuggestMargin !== 'undefined' &&
            _fixedFormDivNoSuggestMargin !== null
          ) {
            document.getElementById(
              'fixed-form-div'
            ).style.paddingBottom = _fixedFormDivNoSuggestMargin;
          }
        }
      },
      empty() {
        if (suggDisplay && suggDisplay[0])
          suggDisplay[0].parentNode.removeChild(suggDisplay[0]);
        if (
          typeof _fixedFormDivNoSuggestMargin !== 'undefined' &&
          _fixedFormDivNoSuggestMargin !== null
        ) {
          document.getElementById(
            'fixed-form-div'
          ).style.paddingBottom = _fixedFormDivNoSuggestMargin;
        }
      },
    });
  };
  emailField = this;
  commonDomains = [
    'yahoo.com',
    'gmail.com',
    'hotmail.com',
    'aol.com',
    'comcast.net',
    'msn.com',
    'sbcglobal.net',
    'verizon.net',
    'att.net',
    'cox.net',
    'live.com',
    'bellsouth.net',
    'ymail.com',
    'charter.net',
    'yahoo.ca',
    'optonline.net',
    'earthlink.net',
    'mac.com',
    'juno.com',
    'me.com',
    'rogers.com',
    'rocketmail.com',
    'aim.com',
    'shaw.ca',
    'roadrunner.com',
    'telus.net',
    'windstream.net',
    'sympatico.ca',
    'embarqmail.com',
    'q.com',
    'live.ca',
    'insightbb.com',
    'frontier.com',
    'netzero.net',
    'netzero.com',
    'mail.com',
    'mchsi.com',
    'netscape.net',
    'hotmail.ca',
    'cogeco.ca',
    'wowway.com',
    'hotmail.co.uk',
    'fuse.net',
    'suddenlink.net',
    'mindspring.com',
    'centurytel.net',
    'sasktel.net',
    'excite.com',
    'tds.net',
    'pacbell.net',
    '163.com',
    'yahoo.co.uk',
    'ameritech.net',
    'yahoo.co.in',
    'prodigy.net',
    'zoominternet.net',
    'cableone.net',
    'swbell.net',
    'rcn.com',
    'mail.ru',
    'eastlink.ca',
    'qq.com',
    'ptd.net',
    'msu.edu',
    'centurylink.net',
    'email.com',
    'yahoo.fr',
    'peoplepc.com',
    'mailinator.com',
    'mts.net',
    'umich.edu',
    'hughes.net',
    'cs.com',
    'gmx.com',
    'rediffmail.com',
    '126.com',
    'us.army.mil',
    'umn.edu',
  ];
  emailField.addEventListener('keyup', () => {
    return getEmailSuggestion();
  });
  //Using delegation pattern here, the event triggered must bubble up for this to work
  emailField.parentNode.addEventListener('click', event => {
    if (event.target.matches('.accept-suggestion')) {
      onEmailSuggestionClicked();
    }
  });
}

Object.defineProperty(Object.prototype, 'emailSuggestions', {
  value: emailSuggestions,
  writable: true,
  configurable: true,
  enumerable: false,
});
